module.exports = __webpack_public_path__ + "img/logohistory.2399b14f.jpg";